import KanaGrid from "@/components/app/KanaGrid";
import { useLang } from "@/context/LanguageContext";
export default function HiraganaPage() {
  const { t } = useLang();
  return <KanaGrid system="hiragana" title={`${t("hiragana")} ひらがな`} subtitle={t("hiraSubtitle")} chartLabel={t("hiraChart")} />;
}
